import AppLayout from '../../components/app-layout/AppLayout'
import CardSurface from '../../components/card-surface/CardSurface'
import TenancySwitcher from '../../components/tenancy-switcher/TenancySwitcher'
import MaintenanceSection from './MaintenanceSection'
import { useResidentTenancy } from '../../_hooks/use-resident-tenancy'
import {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
} from './styled'

/**
 * The renter's Maintenance surface: report issues in the selected residence and
 * track their status. The maintenance section is keyed by the selected tenancy
 * so it remounts (and resets its form + list) when the renter switches homes.
 *
 * @returns {JSX.Element}
 */
const MaintenancePage = (): JSX.Element => {
  const { selectedTenancy, isLoadingTenancies } = useResidentTenancy()

  return (
    <AppLayout contentMaxWidth="standard">
      <PageStack>
        <PageHeader>
          <PageTitle>Maintenance</PageTitle>
          <PageSubtitle>
            Report issues in your home and track them to done.
          </PageSubtitle>
        </PageHeader>

        <TenancySwitcher />

        {isLoadingTenancies === true ? (
          <CardSurface padding="loose">
            <QuietText>Loading…</QuietText>
          </CardSurface>
        ) : null}

        {isLoadingTenancies === false && selectedTenancy === null ? (
          <CardSurface padding="loose">
            <QuietText>
              You don&rsquo;t have any tenancies yet. When your property manager
              invites you, claim the invite from your email to report
              maintenance here.
            </QuietText>
          </CardSurface>
        ) : null}

        {selectedTenancy !== null ? (
          <MaintenanceSection
            key={selectedTenancy.id}
            tenancyId={selectedTenancy.id}
          />
        ) : null}
      </PageStack>
    </AppLayout>
  )
}

export default MaintenancePage
